import datepicker from 'js-datepicker'

( () => {

    const meetingEventsForm = document.querySelector( '.shiftr-form--meeting_events' )

    if( !meetingEventsForm ) {
        return
    }

    const picker = datepicker('.field-date input', {
        customDays: [ 'Su', 'Mu', 'Tu', 'We', 'Th', 'Fr', 'Sa' ],
        formatter: (input, date, instance) => {
            const value = date.toLocaleDateString()
            input.value = value // => '1/1/2099'
        }
    })

})();